import { LabelSelectionGroup, LabelType } from '../../../../store';
import { LabelEditorStyleState } from './editLabelStyleState';
import { EditLabelGroupControls } from './EditLabelGroupControls';
import { EditLabelStyleFields } from './EditLabelStyleFields';
import { LabelStyleWithRotation } from './EditLabel';

interface EditLabelStyleSectionProps {
  marker: LabelType;
  currentLabelGroup: LabelSelectionGroup | null;
  groupName: string;
  groupColor: string;
  canSaveSelectionGroup: boolean;
  styleState: LabelEditorStyleState;
  rotation: number;
  onGroupNameChange: (value: string) => void;
  onGroupColorChange: (value: string) => void;
  onManageGroups: () => void;
  onSaveGroup: () => void;
  onAttributeChange: (attribute: keyof LabelStyleWithRotation, value: string | number) => void;
}

export function EditLabelStyleSection({
  marker,
  currentLabelGroup,
  groupName,
  groupColor,
  canSaveSelectionGroup,
  styleState,
  rotation,
  onGroupNameChange,
  onGroupColorChange,
  onManageGroups,
  onSaveGroup,
  onAttributeChange,
}: EditLabelStyleSectionProps) {
  return (
    <>
      {marker.id !== 'newLabel' && (
        <section className="theme-sidebar__section">
          <h4>Grouping</h4>
          <EditLabelGroupControls
            currentLabelGroup={currentLabelGroup}
            groupName={groupName}
            groupColor={groupColor}
            canSaveSelectionGroup={canSaveSelectionGroup}
            onGroupNameChange={onGroupNameChange}
            onGroupColorChange={onGroupColorChange}
            onManageGroups={onManageGroups}
            onSaveGroup={onSaveGroup}
          />
        </section>
      )}
      <section className="theme-sidebar__section">
        <h4>Style</h4>
        <EditLabelStyleFields
          variant={styleState.variant}
          fontSize={styleState.fontSize}
          fontWeight={styleState.fontWeight}
          color={styleState.color}
          backgroundColor={styleState.backgroundColor}
          backgroundOpacity={styleState.backgroundOpacity}
          borderColor={styleState.borderColor}
          padding={styleState.padding}
          zIndex={styleState.zIndex}
          skewX={styleState.skewX}
          skewY={styleState.skewY}
          perspectiveX={styleState.perspectiveX}
          perspectiveY={styleState.perspectiveY}
          onAttributeChange={onAttributeChange}
          rotation={rotation}
        />
      </section>
    </>
  );
}

export default EditLabelStyleSection;
